import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const verifyMediaTemplateApi = async (payload = {}, authHeaders = {}) => {
  try {
    const body = {
      operation: 'VERIFY_MEDIA_TEMPLATE',
      payload: payload
    };

    const res = await apiCallPost(apiPaths.whatsappTemplate, body, authHeaders);

    if (res) {
      const bodyError = res.error || (res.payload && res.payload.error) || null;
      const statusField = (res.status && typeof res.status === 'string') ? res.status.toUpperCase() : null;

      if (bodyError || statusField === 'FAILED') {
        const errMsg = (bodyError && (bodyError.error || bodyError.message)) || res.message || 'Failed to verify media template';
        return { data: res, status: false, errMsg };
      }

      return { data: res, status: true };
    }

    return { data: {}, status: false, errMsg: 'Failed to verify media template' };
  } catch (err) {
    return { status: false, errMsg: err.message || 'Failed to verify media template' };
  }
};
